module.exports = __webpack_public_path__ + "img/40_38_031_880.1be045bf.jpg";